import $ from 'jquery'
import 'slick-carousel'
export default () => {

  $('.block-carousel > .js-slider:not(.carousel-ready)').each(function () {
      const $slider = $(this);
      const $carousel = $slider.children('.acf-innerblocks-container');

      if (!$carousel.length) return;

      const slideCount = $carousel.children('.block-carousel-slide').length;
      if (slideCount > 1) {
          const options = getSlickOptions($slider);
          $carousel.slick(options);
      }

      $slider.addClass('carousel-ready');
  });

  function getSlickOptions($el) {
      const raw = $el.attr('data-slick');

      if (!raw) return {};

      try {
          return JSON.parse(raw);
      } catch (e) {
          console.error('Invalid data-slick JSON', e);
          return {};
      }
  }
}
